<template>
  <div>
    <el-form :model="tableList" :rules="rules" ref="tableList">
      <el-form-item
        :label="config.manageNews.labelList[0].name"
        :label-width="config.manageNews.labelWidth"
        prop="clusterName"
      >
        <el-input v-model="tableList.clusterName" :style="config.manageNews.inputWidth"></el-input>
      </el-form-item>

      <el-form-item
        :label="config.manageNews.labelList[1].name"
        :label-width="config.manageNews.labelWidth"
          prop="protocal"
      >
        <el-select v-model="tableList.protocal" :placeholder="$translate('lang.E3202103100024', { defaultText: '请选择' })" style="width:100%">
          <el-option label="HTTPS" value="HTTPS"></el-option>
          <el-option label="HTTP" value="HTTP"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="config.manageNews.labelList[2].name"
        :label-width="config.manageNews.labelWidth"
         prop="userName"
      >
        <el-input v-model="tableList.userName"></el-input>
      </el-form-item>
      <el-form-item
        :label="config.manageNews.labelList[3].name"
        :label-width="config.manageNews.labelWidth"
         prop="password"
      >
        <el-input v-model="tableList.password"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import config from '../esConfig.js';

export default {
    props: ['changeData'],
    data() {
        return {
            config: config,
            tableList: this.changeData,
            rules: {
                clusterName: [
                    { required: true, message: this.$translate('lang.E3202103100025', { defaultText: '请填写集群名称' }), trigger: 'blur' }
                ],
                protocal: [{ required: true, message: this.$translate('lang.E3202103100026', { defaultText: '请选择协议' }), trigger: 'change' }],
                userName: [{ required: true, message: this.$translate('lang.E3202103100027', { defaultText: '请输入用户名' }), trigger: 'blur' }],
                password: [{ required: true, message: this.$translate('lang.E3202103100028', { defaultText: '请输入密码' }), trigger: 'blur' }]
            }
        };
    }
};
</script>
<style scoped>
</style>